import {memo} from 'react'
import {SelectProvider} from '@ariakit/react'
import {useTranslation} from '@/translations/i18n'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {SelectItem, SelectList, SelectPopover, SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'
import {ALL_ENTITIES, ExportTabSelection} from '@/features/exports/types'
import {ExportEntityDescriptor} from '@/features/exports/utils/entities'

interface ExportsEntitySelectProps {
    descriptors: ExportEntityDescriptor[]
    activeSelection: ExportTabSelection
    onSelect: (selection: ExportTabSelection) => void
}

const ExportsEntitySelectComponent = ({descriptors, activeSelection, onSelect}: ExportsEntitySelectProps) => {
    const {t} = useTranslation()
    const active = descriptors.find(descriptor => descriptor.key === activeSelection)
    const displayLabel = activeSelection === ALL_ENTITIES ? t('exports:entity_all') : active ? t(active.labelKey) : ''

    return (
        <Flexbox direction="column" gap={1} fullWidth>
            <Text size="textXs" palette="neutral" shade="500">
                {t('exports:filter_data_type')}
            </Text>
            <SelectProvider value={activeSelection} setValue={value => onSelect(value as ExportTabSelection)}>
                <SelectTrigger
                    fullWidth
                    placeholder={t('exports:filter_data_type')}
                    displayValue={() => displayLabel}
                />
                <SelectPopover>
                    <SelectList>
                        <SelectItem value={ALL_ENTITIES} hasItemCheckbox>
                            {t('exports:entity_all')}
                        </SelectItem>
                        {descriptors.map(descriptor => (
                            <SelectItem key={descriptor.key} value={descriptor.key} hasItemCheckbox>
                                {t(descriptor.labelKey)}
                            </SelectItem>
                        ))}
                    </SelectList>
                </SelectPopover>
            </SelectProvider>
        </Flexbox>
    )
}

export const ExportsEntitySelect = memo(ExportsEntitySelectComponent)
